export default {
    "name": "车质宝",
    "full_name": "福州车质宝检测服务有限公司",
    "institution_name": "车质宝检测机构",
    "appraisal_center": "福州某鉴定中心",
    "insurance_company": "太平洋保险公司",
    "mobile": "15606911446",
    "office_line_number": "15606911446",
    "legal_person": "陈美庄",
    "start_up_at": "2021-10-06T16:00:30.285135+08:00",
    "identifier": "6687c175-9ea7-43da-b339-f9fb6a72d103",
    "domain": "chezhibao.ltd",
    "copyright_no": "@车质宝",
    "record_no": "闽ICP备xxxxxx号",
    "is_active": true,
    "create_at": "2021-10-06T16:00:30.285187+08:00",
    "logo_url": "",
    "insurance_company_logo_url": "",
}